// src/pages/SupportPage.js
import React from 'react';
import '../styles/SupportPage.css';

function SupportPage() {
  const faqs = [
    {
      question: 'How do I make a reservation?',
      answer: 'You can make a reservation through our online booking form, by calling us at (214) 984-2522, or by emailing ride@tacttransport.com. We recommend booking at least 48 hours in advance for standard services.',
    },
    {
      question: 'What areas do you serve?',
      answer: 'Tact Transport primarily serves Texas, Louisiana, and Oklahoma. We can accommodate trips outside these areas upon request, which may be subject to additional fees.',
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'For standard services, please cancel at least 24 hours before your scheduled pickup for a full refund. Special events require 7 days notice. Late cancellations may incur a fee of up to 50% of the booking total.',
    },
    {
      question: 'What types of vehicles do you offer?',
      answer: 'Our fleet includes the Mercedes Sprinter, Mercedes Maybach, Range Rover, Cadillac Escalade, GMC Yukon Denali, and Chevy Suburban. Each vehicle is meticulously maintained and professionally cleaned.',
    },
    {
      question: 'Do you provide airport pickup services?',
      answer: 'Yes! We offer airport pickup and drop-off services. Our chauffeurs monitor flight statuses and adjust pickup times accordingly. We typically wait up to 15 minutes for domestic arrivals and 30 minutes for international arrivals at no additional charge.',
    },
    {
      question: 'Are your chauffeurs professionally trained?',
      answer: 'Absolutely. All our chauffeurs undergo extensive background checks, professional training, and are experienced in providing premium service. They are dressed professionally and maintain the highest standards of discretion.',
    },
    {
      question: 'Can I request a specific vehicle or chauffeur?',
      answer: 'Yes, you can request a specific vehicle when booking, subject to availability. If you have had a positive experience with a particular chauffeur, let us know and we will do our best to accommodate your request.',
    },
    {
      question: 'Do you offer armed security services?',
      answer: 'Yes, we offer armed security transportation services upon request. Please contact us directly to discuss your specific security requirements and we will customize a solution for your needs.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards (Visa, MasterCard, American Express, Discover), corporate accounts, and other approved payment methods. A valid credit card is required to secure your reservation.',
    },
    {
      question: 'What if my flight is delayed?',
      answer: 'We actively monitor flight statuses for airport pickups. If your flight is delayed, your pickup time will be automatically adjusted. There is no additional charge for flight delays.',
    },
    {
      question: 'Is gratuity included in the price?',
      answer: 'Gratuity is not included in our quoted rates. While tipping is at your discretion, gratuities are appreciated for excellent service.',
    },
    {
      question: 'Can I make changes to my reservation?',
      answer: 'Yes, you can modify your reservation by contacting us at least 24 hours before your scheduled service. Changes are subject to vehicle availability and may affect pricing.',
    },
  ];

  return (
    <div className="support-page">
      <section className="support-hero">
        <h1 className="support-title">Customer Support</h1>
        <p className="support-subtitle">We're here to help you with any questions</p>
      </section>

      <section className="support-contact">
        <div className="support-contact-grid">
          <div className="support-contact-card">
            <h3>Phone</h3>
            <p>Call us anytime</p>
            <a href="tel:2149842522" className="support-contact-link">(214) 984-2522</a>
          </div>
          <div className="support-contact-card">
            <h3>Email</h3>
            <p>Send us a message</p>
            <a href="mailto:ride@tacttransport.com" className="support-contact-link">ride@tacttransport.com</a>
          </div>
          <div className="support-contact-card">
            <h3>Hours</h3>
            <p>Reservations & Support</p>
            <span className="support-contact-info">24/7 Available</span>
          </div>
        </div>
      </section>

      <section className="support-faq">
        <h2 className="support-faq-title">Frequently Asked Questions</h2>
        <div className="support-faq-list">
          {faqs.map((faq) => (
            <details key={faq.question} className="support-faq-item">
              <summary className="support-faq-question">{faq.question}</summary>
              <p className="support-faq-answer">{faq.answer}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="support-cta">
        <div className="support-cta-content">
          <h2>Still Have Questions?</h2>
          <p>Our team is ready to assist you with any inquiries about our services.</p>
          <div className="support-cta-buttons">
            <a href="tel:2149842522" className="support-cta-button primary">Call Now</a>
            <a href="mailto:ride@tacttransport.com" className="support-cta-button secondary">Email Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SupportPage;
